import { useQuery } from '../../../../ReactQuery';
import { get } from '../../../../redux/api';
import type { UserRoleManagementResponse } from '../../../../../shared/types/routes/organizations';

function fetchUserRoleManagement() {
  return get<UserRoleManagementResponse>('/api/organization/user-role-management');
}

/**
 * React hook to fetch the user role management settings for the current organization.
 */
export default function useUserRoleManagement(enabled: boolean = false) {
  return useQuery<UserRoleManagementResponse>({
    queryKey: ['user-role-management'],
    queryFn: fetchUserRoleManagement,
    enabled,
  });
}
